import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AuthService, UserProfile } from '../../../services/auth.service';
import { finalize } from 'rxjs';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PasswordModule } from 'primeng/password';
import { DialogService } from 'primeng/dynamicdialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputMaskModule } from 'primeng/inputmask';
import { PanelModule } from "primeng/panel";
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-UserProfile',
  standalone: true,
  providers: [DialogService],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule, InputSwitchModule, ButtonModule, CardModule, TranslateModule, PasswordModule, FloatLabelModule, InputMaskModule, PanelModule,  MessageModule],
  templateUrl: './UserProfile.component.html',
  styleUrls: ['./UserProfile.component.scss']
})
export class UserProfileComponent implements OnInit {
  userProfile: UserProfile | null = null;

  passwordForm = new FormGroup({
    newPassword: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(128), this.containsWhitespaceValidator()]),
    confirmPassword: new FormControl('', [Validators.required])
  });
  UserMetaInfomation = new FormGroup({
    FirstName: new FormControl(),
    LastName: new FormControl(),
    Email: new FormControl()
  });

  loading = false;
  successMessage = '';
  errorMessage = '';

  constructor(private authService: AuthService, private translate: TranslateService) {

  }

  ngOnInit() {
    this.userProfile = this.authService.userProfile;
    this.UserMetaInfomation.controls.FirstName.setValue(this.userProfile.email);
    this.UserMetaInfomation.controls.FirstName.setValue(this.userProfile.name);
    this.UserMetaInfomation.controls.LastName.setValue(this.userProfile.name);
  }

  get newPassword() {
    return this.passwordForm.get('newPassword');
  }

  get confirmPassword() {
    return this.passwordForm.get('confirmPassword');
  }

  passwordsDoNotMatch(): boolean {
    let password = this.newPassword?.value;
    let confirm = this.confirmPassword?.value;

    return password && confirm && password !== confirm;
  }

  UpdateUserMetaInfomation() {
//TODO: implement firstname + lastname update on user infomation call
  }

changePassword() {
  this.successMessage = '';
  this.errorMessage = '';

  if (this.passwordForm.invalid || this.passwordsDoNotMatch()) {
    this.passwordForm.markAllAsTouched();
    return;
  }

  const password = this.newPassword?.value;

  this.loading = true;

  this.authService.ChangePassword(password)
    .pipe(finalize(() => this.loading = false))
    .subscribe({
      next: () => {
        this.successMessage = this.translate.instant('USERPROFILE.PASSWORDCHANGEDSUCCESS');
        this.passwordForm.reset();
      },
      error: (err) => {
        console.error(err);
        this.errorMessage = this.translate.instant('USERPROFILE.PASSWORDCHANGEDERROR');
      }
    });
}

  passwordsMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const newPassword = control.get('newPassword')?.value;
      const confirmPassword = control.get('confirmPassword')?.value;

      if (!newPassword || !confirmPassword) {
        return null;
      }

      return newPassword === confirmPassword ? null : { passwordsDoNotMatch: true };
    };
  }
  containsWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string | null;

      if (!value) {
        return null;
      }

      return /\s/.test(value) ? { containsSpaces: true } : null;
    };
  }
}